export enum AlbSubtype {
  Embroidery = 'embroidery',
  Lace = 'lace',
  Hugot = 'hugot',
  Plain = 'plain',
}
